<template>
    <div>
        <np-application-breadcrumb :mode="'arrowcrumb'" :crumbs="tabsToRender"></np-application-breadcrumb>
        <div class="row">
            <div class="col-12">
                <router-view></router-view>
            </div>

        </div>
    </div>
</template>

<script>
    import applicationMixin from "../../utils/application-mixin";
    import navigationMixin from "../../utils/navigation-mixin";
    import NPAppBreadcrumb from "../../components/np-application-breadcrumb.vue";
    import {NPSkeleton} from "netpify/components";
    import * as types from "../../stores/constants";
    import {mapActions} from "pinia";
    import EventBus from "../../utils/event_bus";
    import useApplicationStore from "../../stores/application_module";

    export default {
        name: "ApplicationEdit",
        mixins: [applicationMixin, navigationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data: () => {
            return {
                application: [],
            }
        },
        mounted() {
            if (!this.objectIsNotEmpty(this.parameters)){
                // I just made this async - nothing else :) //TODO seems nothing after then works
                useApplicationStore()[types.FETCH_APPLICATION_PARAMETERS]().then(obj => {

                    //TODO
                    //redirected from application/add when quote was initiated.
                    // if (this.objectIsNotEmpty(this.quote) && !this.isConvertedQuote) {
                    //     this.setQuoteRootPath(this.quote.quote_external_id, 'edit')
                    // } else
                   if (!!this.$route.params.quote_id && !this.quote.hasOwnProperty('quote_external_id')) {
                        this.fetchQuoteData(this.$route.params.quote_id);
                    } else if (this.quote.hasOwnProperty('quote_external_id') && !this.isLockedQuote) {
                        this.setQuoteRootPath(this.quote.quote_external_id, 'edit')
                    }
                }).then(res => {
                    //get application data
                    if (!this.merchant.hasOwnProperty('application_reference') || this.merchant.application_reference === '') {
                        this.fetchApplicationData(this.$route.params.application_reference)
                    } else {
                        // if ()
                        //this is pushing undefined to the route.
                        // this.setApplicationRootPath(this.merchant.application_reference);
                    }
                });
            }
            //TODO we have an issue if the user types into the url field.
            //because don't fetch the details if they are already there, we can't set the root paths for quote and application
            //check the fullPath watch
        },
        created() {
            let vm = this;
            //when faster payment option is changed based on bank, we listen and update offer
            EventBus.on('outlet-online_offer-update', (payload) => {vm.setQuoteOfferByOutlet(payload, 'online')})
            EventBus.on('outlet-equipment_offer-update', (payload) => {vm.setQuoteOfferByOutlet(payload, 'equipment')})
        },
        computed: {
            tabsToRender: function () {
                let vm = this, tabs = this.jsonCopy(this.portal_tabs);
                tabs.forEach((obj, index) => {

                    //if application is submitted, disabled steps 1-3 and mark them as complete.
                    //quote has been converted and application created
                    if (vm.isConvertedQuote && vm.isLockedQuote) {
                        //if quote is converted, set step one to is_complete.
                        if (obj.is_quote_tab) {
                            obj.is_complete = true;
                        }
                        if ((obj.is_application_tab && !this.isOpenApplication)) {
                            obj.is_complete = true;
                            // obj.is_active = false; //TODO we need to rethink what it will act like when it's completed.
                        }
                    }

                    if (obj.is_quote_tab) {
                        obj.url = this.quote_root_path + obj.url;
                    } else {
                        obj.url = this.application_root_path + obj.url;
                    }

                    if (vm.npPropertyExistAndIsArray(obj, 'subitems')) {
                        obj.subitems.forEach(sub => {
                            sub.url = obj.url + sub.url
                        })
                    }
                });

                return tabs;
            },
        },
        methods: {
            ...mapActions(useApplicationStore,[
                types.FETCH_APPLICATION_PARAMETERS,
                types.FETCH_QUOTE_DATA,
                types.FETCH_APPLICATION_DATA]),
            ...mapActions(useApplicationStore, [
                types.SET_QUOTE_LOCK,
                types.SET_QUOTE_ROOT_PATH,
                types.SET_APPLICATION_ROOT_PATH,
                types.COMMIT_APPLICATION_TABS]),
            fetchQuoteData: async function (quote_external_id) {
                let vm = this;

                if (quote_external_id === '' || typeof quote_external_id === 'undefined') {
                    if (this.isPublicUser) {
                        //get quote external id from cookie
                        quote_external_id = this.getCookie('elavon_v3_quote_id');
                        //console.log(quote_external_id)
                    } else {
                        //get quote data for first quote in merchant user_access
                        quote_external_id = vm.merchant_user_access.quote[0]['quote_external_id'];
                    }
                }
                let payload = {
                    'user_external_id': vm.user.user_external_id,
                    'quote_external_id': quote_external_id,
                }

                //fetch and commit Quote Data
                await vm[types.FETCH_QUOTE_DATA](payload);

                //DEPRECATED - ensures that quote is in view mode when application is in edit
                vm.setQuoteRootPath(quote_external_id, 'edit');
                // get application data for application root path
                let quote_data = vm.merchant_user_access.hasOwnProperty('quote') ? vm.merchant_user_access.quote.find(obj => {
                    return obj.quote_external_id === quote_external_id
                }) : {};

                let application = vm.merchant_user_access.hasOwnProperty('application') ? vm.merchant_user_access.application.find(obj => {
                    return obj.application_external_id === quote_data.application_external_id
                }) : {};

                if (!!application && application.hasOwnProperty('application_reference') && !!application.application_reference) {
                    vm.setApplicationRootPath(application.application_reference, 'edit')
                    //fetch application when on step 1 pages
                    if (!vm.merchant.hasOwnProperty('application_reference') || this.merchant.application_reference === '') {
                        vm.fetchApplicationData(application.application_reference)
                    }
                }
            },
            fetchApplicationData: function (application_reference) {
                let vm = this;
                if (application_reference !== '' && typeof application_reference !== 'undefined') {

                    let payload = {
                        application_reference: application_reference,
                    }

                    //if the entry is from an application/ and we don't have quote get quote
                    if (!vm.objectIsNotEmpty(vm.quote) && vm.merchant_user_access.hasOwnProperty('application')) {
                        let application_data = vm.merchant_user_access.application.find(obj => {
                            return obj.application_reference === application_reference
                        })
                        if (!!application_data) {
                            vm.setQuoteRootPath(application_data.quote_external_id, 'edit')

                            // vm.fetchQuoteData(application_data.quote_external_id, true);
                        }
                    }

                    //fetch and commit Application
                    vm[types.FETCH_APPLICATION_DATA](payload).then(obj => {
                        vm.setApplicationRootPath(application_reference, 'edit');
                    }).then(res => {
                        if (!vm.objectIsNotEmpty(vm.quote))
                        vm.fetchQuoteData(vm.merchant.quote_external_id);
                    });
                }
            }
        },
        watch: {
            "$route.params.quote_id": {
                handler: function (val, oldVal) {
                    if (val !== '' && typeof val !== 'undefined' && val !== this.quote.quote_external_id) {
                        this.fetchQuoteData(val);
                    }
                }
            },
            "$route.params.application_reference": {
                handler: function (val, oldVal) {
                    if (val !== '' && typeof val !== 'undefined' && val !== this.merchant.application_reference) {
                        this.fetchApplicationData(val)
                    }
                }
            },
            'tabsToRender': {
                immediate: true,
                handler: function (val, oldVal) {
                    if (!!val) {
                        this[types.COMMIT_APPLICATION_TABS](val);
                    }
                }
            }
            // "$route.fullPath": function (val, oldVal){
            //     if (!!val){
            //         //console.log(val)
            //         // if (the action in the full path doesn't match the action in the rootpath){
            //         //check if there is quote and application
            //         // redirect or change the tabsToRender? this depends on who we trust since it's edit page though, both quote and application should be in edit
            //         //get their ids and then set the tabsToRender to edit mode
            //     }
            // }
        }
    }
</script>

<style scoped>

</style>